

<div class="row">
  <div class="col-md-10 col-10">
    <h3 mat-dialog-title >{{ 'CancelationConfirmation' | translate }}</h3>
  </div>
  <div class="col-md-2 col-2 p-0">
      <button mat-dialog-action class="btnLink closeModal text-right" (click)="close()"> <fa-icon [icon]="faTimesCircle"></fa-icon></button>
  </div>
</div>

<mat-dialog-content  class="cancel-modal">
  <div class="row ">
    <div class="col-md-8">
    <div *ngIf="refundableAmountValue <= 0">
      <p>{{ 'YourBooking' | translate }} <span class="text-blue">{{viewBooking.bookingNumber}}</span> {{ 'hasbeencanceledsuccessfulymsg' | translate }}. </p>
    </div>
    <div *ngIf="refundableAmountValue > 0">
      <p>
        {{ 'YourBooking' | translate }}  <span class="text-blue">{{viewBooking.bookingNumber}}</span> {{ 'HasBeenCanceled' | translate }},  <span class="text-blue">{{refundableAmountValue}}</span> {{currency}}  {{"RefundedMsg" | translate}} 
      </p>



      <!-- <p>{{ 'YourBooking' | translate }}  <span class="text-blue">{{viewBooking.bookingNumber}}</span> {{ 'hasbeencanceledsuccessfulymsg' | translate }}
        <span class="text-blue">{{refundableAmountValue}}</span> {{currency}}
        {{ 'hasbeenrefundedbacktoyourcreditaccount' | translate }} {{'youcanvisitourbranchtogetthemincashoranyothercovenientmethod' | translate}}
      </p>
      <p class="mt-3">{{ 'Amountwillbeaddedtoyourcreditcard' | translate }}</p> -->
    </div>
 
          
    
    
    </div>
    <div class="col-md-4">
      <img class="img-fluid" src='assets/img/cancelled.svg' />
    </div>
  </div>

  <div class="row mt-3">
    <div class="col-md-12 d-flex justify-content-start">
      <!-- <button class="btn btn-default btn-print"><mat-icon class="mr-3">print</mat-icon>{{  'Print' | translate  }}</button> -->
      <button (click)="close()" class="btn default-cancel-btn" mat-button>{{ 'Close' | translate }}</button>
    </div>
  </div>
</mat-dialog-content>


